export const PAGE_ROUTES = {
  DEVELOPERS: "developers",
  VERIFY: "verify",
  ACCESS_DENIED: "access-denied",
  ACCOUNT_CONFIGURATION: "account-configuration",
  PENDING_REGISTRATION: "pending-registration",
  ADMIN: "admin",
  PARTNER: "partner",
  ACTIVATION_CODES: "activationCodes",
  SMS_MARKETING: "distributions",
  QUICK_SETUP: "quick-setup",
  QUICK_SETUP_INTEGRATION: "quick-setup-integration",
  PARTNER_ONBOARDING: "partner-onboarding",
  CAMPAIGN_CONFIGURATION: "campaign-configuration",
  CARD_VERIFY: "card-verify",
  CONFIGURE_APP_BY_LOCATION: "configure-app/:locationId/:widgetId",
  CONFIG_ERROR: "config-error",

  // REPORT ROUTES:
  REPORT: "report",
  REPORT_TERMINAL_ACTIVITY: "report/terminal-activity",
  REPORT_APP_ACTIVITIES: "report/app-activities",
  REPORT_SMART_PAGE_ACTIVITIES: "report/smart-page-activities",
  REPORT_TOP_SALES_PERSON: "report/top-sales-person",
  REPORT_ENGAGEMENT_ATTEMPTS: "report/engagement-attempts",
  REPORT_ENGAGEMENT_OUTCOMES: "report/engagement-outcomes",
  REPORT_ACTIVITIES_BY_LOCATION: "report/activities-by-location",
  REPORT_SHORT_LINKS: "report/short-links",
  REPORT_TOP_COMPANIES: "report/top-companies",
  REPORT_TOP_PARTNERS: "report/top-partners",
  REPORT_TOP_LOCATIONS: "report/top-locations",

  // MANAGER ROUTES:
  MANAGER_LOCATIONS: "manager/locations",
  MANAGER_DEVICES: "manager/devices",
  MANAGER_PIXEL_TAGS: "manager/pixel-tags",
  MANAGER_SHORT_URLS: "manager/short-urls",
  MANAGER_BULK_LINKS: "manager/bulk-links",
  MANAGER_NFC_PRODUCTS: "manager/nfc-products",
  MANAGER_DEVICES_EDIT: "manager/devices/edit/:deviceId",
  MANAGER_LOCATIONS_CFSTERMINALS: "manager/locations/cfsterminals",
  MANAGER_LOCATIONS_CFSTERMINALS_LOCATION: "manager/locations/cfsterminals/:locationId",
  MANAGER_LOCATIONS_ADD: "manager/locations/add",
  MANAGER_LOCATIONS_EDIT: "manager/locations/:locationId",
  MANAGER_USERS: "manager/users",
  MANAGER_USERS_ADD: "manager/users/add",
  MANAGER_USERS_EDIT: "manager/users/modifyUser/:id",
  MANAGER_CUSTOMERS: "manager/customers",
  MANAGER_MY_BRAND: "manager/my-brand",
  MANAGER_PRICING_PLAN: "manager/pricing-plan",
  MANAGER_SETTINGS: "manager/settings",
  MANAGER_EXTERNAL_FEATURES: "manager/external-features",
  MANAGER_APP_SETTINGS: "manager/app-settings",
  MANAGER_PRODUCT_UPDATE: "manager/product/update/:id",
  MANAGER_PRODUCT_ADD: "manager/product/add",
  MANAGER_PRODUCTS_BY_LOCATION: "manager/products/location/:id",
  MANAGER_TEMPLATES: "manager/templates",
  MANAGER_POS_RULES: "manager/pos-rules",
  MANAGER_POS_ACTIVITY_REPORT: "manager/pos-activity-report",
  MANAGER_POS_RULES_ADD: "manager/pos-rules/add",
  MANAGER_POS_RULES_EDIT: "manager/pos-rules/edit/:conditionId",
  MANAGER_POS_CONFIGURATION: "manager/pos-configuration",
  MANAGER_POS_TERMINAL_MODES: "manager/pos-terminal-modes",
  MANAGER_POS_MARKETPLACE: "manager/pos-marketplace",
  MANAGER_POS_DATA_SYNC: "manager/pos-marketplace/pos-data-sync",
  MANAGER_POS_RECEIPT_SETTINGS: "manager/pos-receipt-settings",
  MANAGER_POS_THANK_YOU_PAGE: "manager/pos-thank-you-page",
  MANAGER_POS_THANK_YOU_PAGE_EDIT: "manager/pos-thank-you-page/edit",
  MANAGER_IMPORTED_COUPONS: "manager/imported-coupons",
  MANAGER_IMPORTED_COUPON_DETAILS: "manager/imported-coupons/:id",
  MANAGER_IMPORTED_TRANSACTIONS: "manager/imported-transactions",
  MANAGER_IMPORTED_TRANSACTION_DETAILS: "manager/imported-transactions/:id",
  MANAGER_EXTERNAL_FEATURE: "manager/external-feature"
};
